<div class="card">
	<h4>Yelp Integration</h4>
</div>

<div class="card">
	<div *ngIf="!loading; else loadingDiv">
		<div *ngIf="yelpEnabled && apiKey">
			<a
				*ngIf="yelpAuthorizationLink"
				[href]="yelpAuthorizationLink"
				style="display: inline-block; margin-bottom: 1rem;"
			>Authorize application</a>
			<p>Yelp Integration is Enabled</p>
			<button
				pButton
				class="p-button-danger"
				label="Subscribe to Businesses"
				(click)="subscribeToBusinesses()"
			></button>
		</div>
		<p *ngIf="!yelpEnabled || !apiKey"><p-message
			severity="error"
			text="Yelp has not been configured for this application"
		></p-message></p>
	</div>
</div>

<ng-template #loadingDiv>
	<p-skeleton></p-skeleton>
</ng-template>